export default __webpack_public_path__ + "static/media/icon_task.fd3dd0bf.svg";